import React from "react";

const Hero = ({ setIsFormOpen }) => {
  return (
    <div className="virtual-events-hero">
      <div className="container">
        <div>
          <h1 className="virtual-events-hero__title">
            We’ll help you plan your perfect virtual event.
          </h1>
          <p className="virtual-events-hero__copy">
            Here at VenueScanner, we’ve handpicked the top activities and
            suppliers to ensure your next virtual event isn’t just another Zoom
            call.
          </p>
          <button
            className="button button--light"
            onClick={() => setIsFormOpen(true)}
            data-ga={`virtual_events_hero--enquire-now`}
          >
            Enquire Now
          </button>
          <div className="virtual-events-hero__partners">
            <img
              src="https://s3.eu-west-2.amazonaws.com/venue.scanner/logos/yum_white.svg"
              alt="Yum partner logo"
            />
            <img
              src="https://s3.eu-west-2.amazonaws.com/venue.scanner/logos/bbc_white.svg"
              alt="BBC partner logo"
            />
            <img
              src="https://s3.eu-west-2.amazonaws.com/venue.scanner/logos/pwc_white.svg"
              alt="PWC partner logo"
            />
            <img
              src="https://s3.eu-west-2.amazonaws.com/venue.scanner/logos/savills_white.svg"
              alt="Savills partner logo"
            />
          </div>
        </div>
        <div className="virtual-events-hero__images">
          <img
            className="virtual-events-hero__images__image"
            src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/hero_lady_1.png"
            alt="Kareoke facetime"
          />
          <img
            className="virtual-events-hero__images__image"
            src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/hero_lady_2.png"
            alt="Drinking facetime"
          />
          <img
            className="virtual-events-hero__images__image"
            src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/hero_laptop.png"
            alt="Concert via facetime"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
